import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import AddNote from './AddNote';
import { fetchCaseNotes } from '../../reducers/caseNotes';
import Messages from './Messages';
import EchoEventListener from '../EchoProvider/EchoEventListener';

const useStyles = makeStyles(() => {
  return {
    wrapperFixed: {
      width: '100%',
      maxWidth: '900px',
      minHeight: '400px',
      maxHeight: '600px'
    },
    wrapperFlexible: {
      width: '98vw !important',
      height: '98vh !important'
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
});

const CaseNotes = ({ patientId, messages, fetch, fetching, initialized, flexible }) => {
  const classes = useStyles();

  useEffect(() => {
    if (initialized || fetching) {
      return;
    }
    fetch();
  }, [fetch, fetching, initialized]);

  const eventHandler = () => fetch(true);

  const classNames = [classes.wrapper];
  classNames.push(flexible ? classes.wrapperFlexible : classes.wrapperFixed);

  return (
    <EchoEventListener
      channelName={`patient.${patientId}`}
      eventName="new-message"
      callback={eventHandler}
    >
      <Box width="100%" display="flex" justifyContent="center">
        <Paper className={classNames.join(' ')}>
          <Messages messages={messages} />
          <AddNote patientId={patientId} />
        </Paper>
      </Box>
    </EchoEventListener>
  );
};

CaseNotes.propTypes = {
  patientId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  messages: PropTypes.array.isRequired,
  fetch: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  initialized: PropTypes.bool.isRequired,
  flexible: PropTypes.bool
};

CaseNotes.defaultProps = {
  flexible: false
};

export default connect(
  (state, { patientId }) => {
    const localState = state.caseNotes;
    const patientState = localState.patientId === patientId ? localState : {};

    return {
      messages: patientState.messages || [],
      fetching: patientState.fetching || false,
      initialized: patientId === patientState.patientId
    };
  },
  (dispatch, { patientId }) => {
    return {
      fetch: (onlyNew = false) => dispatch(fetchCaseNotes(patientId, onlyNew))
    };
  }
)(CaseNotes);
